import { render, staticRenderFns } from "./ChannelIndex.vue?vue&type=template&id=9b9c1ece&scoped=true&"
import script from "./ChannelIndex.vue?vue&type=script&lang=js&"
export * from "./ChannelIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChannelIndex.vue?vue&type=style&index=0&id=9b9c1ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9c1ece",
  null
  
)

export default component.exports